<script>
    import {createEventDispatcher} from 'svelte/internal';
    import {clickOutside} from '../../lib/clickOutside.js';
    import {formatDate, setFocusTo} from "../../lib/lib";
    import Icon from "../Icon.svelte";
    import CalendarControl from "./CalendarControl.svelte";

    export let value = null;
    export let id = 'datepicker-' + Math.random();
    export let readonly = true;
    export let iconOnly = false;
    export let hideToday = false;
    export let hideClear = false;
    export let placeholder = null;
    export let topInfo = null;
    export let bottomInfo = null;

    let inputDate = null;
    let showCalendar = false;

    const dispatch = createEventDispatcher();

    const handleEscapeKey = event => {
        if (event.key === 'Escape') {
            closeCalendar();
        }
    }

    const toggleCalendar = () => {
        if (!showCalendar) {
            openCalendar();
        } else {
            closeCalendar();
        }
    }

    const openCalendar = () => {
        if (!showCalendar) {
            showCalendar = true;
            document.addEventListener('keydown', handleEscapeKey);
        }
    }

    const closeCalendar = () => {
        if (showCalendar) {
            showCalendar = false;
            document.removeEventListener('keydown', handleEscapeKey);
        }
    }

    const onCalendarDateChange = ({detail}) => {
        value = detail;
        closeCalendar();
        dispatch('change', value);
        setFocusTo(id);
    }

    const onInputClick = () => {
        if (readonly || !value) {
            openCalendar();
        }
    }

    const onInputChange = (event) => {
        if (event.target.value) {
            let newDate = formatDate(event.target.value, 'y-m-d');
            let dt = new Date(newDate);
            if (dt instanceof Date && !isNaN(dt)) {
                value = formatDate(dt, 'y-m-d');
                dispatch('change', value);
            } else {
                // date = null;
                console.log("wrong date");
            }
        } else {
            value = null;
            dispatch('change', value);
        }
    }

    $:{
        inputDate = formatDate(value, 'd-m-y');
    }
</script>

<div class="date-control" class:form-item={ topInfo || bottomInfo }>
    {#if iconOnly}
        <div class="date-icon" on:click="{ toggleCalendar }">
            <Icon name="calendar" size="18"/>
        </div>
    {:else}
        <input type="text" class="form-control" {id} value="{ inputDate }" readonly="{readonly}"
               on:click="{ onInputClick }" on:change="{ onInputChange }" {placeholder}>
        {#if !inputDate}
            <div class="input-icon" on:click="{ openCalendar }">
                <Icon name="calendar"/>
            </div>
        {/if}
    {/if}
    {#if topInfo}
        <div class="form-item-info top">
            { topInfo}
        </div>
    {/if}
    {#if bottomInfo}
        <div class="form-item-info">
            { bottomInfo}
        </div>
    {/if}
    {#if showCalendar}
        <div class="calendar" class:centered={ iconOnly } use:clickOutside on:click_outside="{ closeCalendar }">
            <CalendarControl date="{ value }" {hideToday} {hideClear} on:change="{ onCalendarDateChange }"/>
        </div>
    {/if}
</div>

<style>
    .date-control {
        position: relative;
    }

    /*.date-control .form-control {*/
    /*    min-width: 130px;*/
    /*}*/

    .date-icon {
        line-height: 1;
        padding: 5px 10px;
        cursor: pointer;
    }

    .input-icon {
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
        line-height: 1;
        padding: 5px 10px;
        cursor: pointer;
    }

    .calendar {
        position: absolute;
        box-shadow: var(--dropdown-box-shadow);
        z-index: 5000;
    }

    .calendar.centered {
        left: 50%;
        transform: translatex(-50%);
    }
</style>